import { Component } from '@angular/core';

@Component({
  selector: 'app-icon-telegram',
  imports: [],
  templateUrl: './icon-telegram.component.html',
  styleUrl: './icon-telegram.component.scss'
})
export class IconTelegramComponent {

}
